var render, staticRenderFns
import script from "./SectionTitle.vue?vue&type=script&lang=js"
export * from "./SectionTitle.vue?vue&type=script&lang=js"
import style0 from "./SectionTitle.vue?vue&type=style&index=0&id=6ea1e172&prod&scoped=true&lang=scss"
import style1 from "./SectionTitle.vue?vue&type=style&index=1&id=6ea1e172&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea1e172",
  null
  
)

export default component.exports